import { eduIDApi } from "./common";
export const ladokApi = eduIDApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchLadokUniversities: builder.query({
            query: () => ({
                url: "universities",
            }),
            extraOptions: { service: "ladok" },
        }),
        linkUser: builder.query({
            query: (body) => ({
                url: "link-user",
                body,
            }),
            extraOptions: { service: "ladok" },
        }),
        unlinkUser: builder.query({
            query: () => ({
                url: "unlink-user",
                body: {},
            }),
            extraOptions: { service: "ladok" },
        }),
    }),
});
